

WB.Components = WB.Components || {};
WB.Components.PreloaderDirectiveLink = function() {
    return function(scope, element, attr) {
        scope.size = scope.size || 'big';
    };
};

WB.Components.PreloaderDirective = function() {
    return {
        restrict: 'AE',
        scope: {
            color: '@',
            size: '@?'
        },
        link: WB.Components.PreloaderDirectiveLink(),
        template: `<div class="preloader-wrapper active {{ size }}">
        <div class="spinner-layer spinner-white-only"
            ng-style="{
                'border-color': color
            }">
            <div class="circle-clipper left">
                <div class="circle"></div>
            </div>
            <div class="gap-patch">
                <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
                <div class="circle"></div>
            </div>
        </div>
    </div>`
    };
};
WB.Components.PreloaderDirective.$inject = [];

WB.App.directive('wbPreloader', WB.Components.PreloaderDirective);
